import gsap from 'gsap';
import { Mesh, PlaneBufferGeometry, TextureLoader } from 'three';
import { FullScreenQuadMaterial } from './materials/FullScreenMaterial';

import texture from '../assets/textures/vignetting.png';

export class Vignetting extends Mesh {
  constructor() {
    const textureLoader = new TextureLoader();
    const geometry = new PlaneBufferGeometry(2, 2, 1, 1);
    const material = new FullScreenQuadMaterial({
      color: 0xffffff,
      map: textureLoader.load(texture),
      opacity: 1,
      transparent: true,
      depthWrite: false,
      depthTest: false
    });

    super(geometry, material);

    this.frustumCulled = false;
  }

  fadeIn() {
    const tweenValues = { opacity: 0 };
    gsap.to(tweenValues, {
      opacity: 0.5,
      duration: 3,
      onUpdate: () => {
        this.material.uniforms.opacity.value = tweenValues.opacity;
      }
    })
  }
}